import React, { useState } from 'react';
import { TabsElement as TabsType } from '../../types/element.types';

interface TabsElementProps {
  element: TabsType;
}

/**
 * Tabs Element Renderer
 * Tabbed content interface
 */
const TabsElement: React.FC<TabsElementProps> = ({ element }) => {
  const { tabs } = element.content || { tabs: [] };
  const [activeTab, setActiveTab] = useState(tabs[0]?.id || '');

  const activeTabContent = tabs.find((tab) => tab.id === activeTab);

  return (
    <div
      className="tabs-element"
      style={element.styles as React.CSSProperties}
    >
      {/* Tab Headers */}
      <div className="flex border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`
              px-4 py-2 font-medium transition-all
              ${
                activeTab === tab.id
                  ? 'border-b-2 border-primary-600 text-primary-600'
                  : 'text-gray-600 hover:text-gray-900'
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="p-4">
        {activeTabContent?.content || 'No content'}
      </div>
    </div>
  );
};

export default TabsElement;

